import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./App.js";
import ZDWST_STATE_VERSION_TYPE from './redux/types/ZdwstStateVersionType.js';
import {createStore} from 'redux';
import {Provider} from 'react-redux';
import {finalReducer} from './redux/reducers/finalReducer.js';
import './config.js';
import reportWebVitals from './reportWebVitals';

const loadState = () => {
  try { // 也可以容错一下不支持localStorage的情况下，用其他本地存储
    const serializedState = localStorage.getItem('zdwst-state');
    if (serializedState === null) {
      return undefined;
    } else {
      let state1 = JSON.parse(serializedState);
      if (state1.version < global.constants.const_state_version) {
        return undefined;
      } else {
        return state1;
      }
    }
  } catch (err) {
    // ... 错误处理
        return undefined;
  }
};

var store;
store = createStore(finalReducer, loadState());
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('zdwst-state', serializedState);
  } catch (err) {
    // ...错误处理
  }
};

window.onbeforeunload = (e) => {
  store.dispatch({
    type: ZDWST_STATE_VERSION_TYPE,
    payload: global.constants.const_state_version  // 代码全局变量，随工程配置一起处理即可。每次涉及需要更新state的时候，必须更新此版本号。
  });
  const state = store.getState();
  saveState(state);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
